@if (summarySorted?.length > 0 && series_events && statusColumns &&
  extraColumns) {
  <table (matSortChange)="sortData($event)" [dataSource]="dataSource" class="series-table" mat-table matSort>
    @for (column of statusColumns; track column) {
      <ng-container [matColumnDef]="column" sticky>
        <th *matHeaderCellDef [id]="column" [mat-sort-header]="column"
          [style.width]="format_dict[column].width + 'px'" [ngClass]="{'hideonprint': hide_on_print.includes(column)}"
          class="freeze-pane" [resizable]="format_dict[column]" (resizable)="format_dict[column].width=$event"
          mat-header-cell [constrainWidth]="config.constrain_width">
          @if (column !== 'Status') {
            {{format_dict[column].title}}
          }
          @if (column === 'Status') {
            <i class="icon-status"></i>
          }
        </th>
        <td *matCellDef="let element;" mat-cell
          [ngClass]="{'bold': hovering_events.includes(element.ID), 'hideonprint': hide_on_print.includes(column)}"
          [ngStyle]="format_dict[column].style" style="alignment: left; text-align: left">
          @if (column === 'Status') {
            <span class="fa flag flag--status fa-warning"
              [ngClass]="{'warning-none': !element[column] || element[column]==1, 'warning' : element[column]==2, 'error': element[column]==3}">
            </span>
            <!--<i [ngClass]="{'status-warn': element[column] === 2, 'status-action': element[column] === 3}"></i>-->
          }
          @if (column === 'Name') {
            <div class="row auto center" [style.width]="format_dict[column].width + 'px'"
              [style.justify-content]="format_dict[column].style['text-align']==='right' ? 'flex-end' : format_dict[column].style['text-align']==='center' ? 'center':'flex-start'">
              @if (isSticky[column]) {
                <i (click)="editSeries(element)" class="edit-inline hide-xs hideonprint"></i>
              }
              <a (debounceClick)="openChartDialog(element[column])" [dblClickCopy]="element['Name']"
              [textContent]="element[column]" style="cursor:pointer;"></a>
              @if (element['kpi_level'] === 'Level 1') {
                <span
                class="kpi">KPI {{(element['kpi_level']).replace('Level', '')}}</span>
              }
            </div>
          }
          @if (column === 'Alias') {
            <div [ngClass]="{'editable':isSticky[column] } " class="row auto center" [style.width]="format_dict[column].width + 'px'"
              [style.justify-content]="format_dict[column].style['text-align']==='right' ? 'flex-end' : format_dict[column].style['text-align']==='center' ? 'center':'flex-start'">
              @if (isSticky[column]) {
                <i (click)="editSeries(element)" class="edit-inline hide-xs hideonprint"></i>
              }
              <a (debounceClick)="openChartDialog(element[column])" [dblClickCopy]="element['Name']"
              [textContent]="element[column]" style="cursor:pointer;"></a>
              @if (element['kpi_level'] === 'Level 1' && isSticky[column]) {
                <span
                class="kpi">KPI {{(element['kpi_level']).replace('Level', '')}}</span>
              }
            </div>
          }
          @if (column === 'Description') {
            <div [ngClass]="{'editable':isSticky[column] } "
              class="row auto center">
              @if (isSticky[column]) {
                <i (click)="editSeries(element)"
                class="edit-inline hide-xs hideonprint"></i>
              }
              <a (debounceClick)="openChartDialog(element['Name'])" [dblClickCopy]="element['Name']"
                [textContent]="element[column]"
              [style.width]="tableUtils.setDescriptorWidth(column, element, format_dict, statusColumns)"></a>
              @if (element['kpi_level'] === 'Level 1' && isSticky[column]) {
                <span
                class="kpi">KPI {{(element['kpi_level']).replace('Level', '')}}</span>
              }
            </div>
          }
        </td>
      </ng-container>
    }
    <series-detail-table [series_ids]="series_ids" [table_extract]="true"
    (seriesDetails)="series_details=$event"></series-detail-table>
    @for (column of extraColumns; track column) {
      <ng-container [matColumnDef]="column">
        @if (column !== 'Sparkline') {
          @if (!customColumns.includes(column)) {
            <th *matHeaderCellDef [mat-sort-header]="column"
              [style.width]="format_dict[column].width + 'px'" [resizable]="format_dict[column]"
              (resizable)="format_dict[column].width=$event" [constrainWidth]="config.constrain_width"
              [matTooltip]="col_dict[column]?.description?col_dict[column]?.description:''"
              mat-header-cell>
              <div [textContent]="format_dict[column].title"></div>
            </th>
          }
          @if (customColumns.includes(column)) {
            <th *matHeaderCellDef [mat-sort-header]="column" [style.width]="format_dict[column].width + 'px'"
              [textContent]="column" [resizable]="format_dict[column]" (resizable)="format_dict[column].width=$event"
              mat-header-cell [constrainWidth]="config.constrain_width">
              <div [textContent]="format_dict[column].title"></div>
            </th>
          }
          <td (debounceClick)="openChartDialog(element['Name'])" [dblClickCopy]="element[column]"
          *matCellDef="let element;" [ngClass]="{'favourable': favourabilityFormats?.[element.ID]?.[column]===true,
                'unfavourable': favourabilityFormats?.[element.ID]?.[column]===false,'trend-cell' : column.includes('Trend')}"
            [ngStyle]="format_dict[column].style" mat-cell
            >
            @if (!customColumns.includes(column) && !column.toString().includes(trendColumn)) {
              @if (col_dict[column]?.contentFilter === 'date') {
                {{element[column] | stringDate}}
              }
              @if (col_dict[column]?.contentFilter !== 'date' && column.toString().includes('%')) {
                {{element[column] | percent:'1.2-2' |
                formatNumber:((significant_numbers ? ((element['DecimalPlaces'] || element['DecimalPlaces'] === 0) ? element['DecimalPlaces'] : format_dict[column].decimals) : null)):significant_numbers | thousandsSeparate}}
              }
              @if (col_dict[column]?.contentFilter !== 'date' && !column.toString().includes('%') && column!='Unit') {
                {{element[column] |
                formatNumber:((significant_numbers ? ((element['DecimalPlaces'] || element['DecimalPlaces'] === 0) ? element['DecimalPlaces'] : format_dict[column].decimals) : null)):significant_numbers
                | thousandsSeparate}}
              }
              @if (column=='Unit') {
                <ng-container (debounceClick)="openChartDialog(element['Name'])" [dblClickCopy]="element[column]"
                  >{{element[column]}}
                </ng-container>
              }
            }
            @if (column.toString().includes(trendColumn)) {
              <i class="fa" [ngClass]="{'fa-caret-up': element[column]==='positive','fa-caret-down':element[column]==='negative'}"
              ></i>
            }
            @if (customColumns.includes(column)) {
              @if (editing) {
                <input (click)="$event.stopPropagation();"
                  [(ngModel)]="config.column_text[column][element['Name']]">
              }
              @if (!editing) {
                <div>
                  {{config.column_text?.[column]?.[element['Name']]}}
                </div>
              }
            }
          </td>
        }
        @if (column == 'Sparkline') {
          <th *matHeaderCellDef [mat-sort-header]="column" [textContent]="format_dict[column].title" mat-header-cell></th>
          <td *matCellDef="let element;" mat-cell (debounceClick)="openChartDialog(element['Name'])"
            [dblClickCopy]="element[column]">
            <sparkline [data_points]="element.Sparkline" [series_name]="element[column]"></sparkline>
          </td>
        }
      </ng-container>
    }
    <ng-container matColumnDef="Comments">
      <th *matHeaderCellDef mat-header-cell style="width: 40px;min-width: 40px;" class="hideonprint">
        <div style="padding:0;"><i class="icon-comment-invert" style="padding-top:0;"></i></div>
      </th>
      <td *matCellDef="let element;" mat-cell style="text-align: center;" class="hideonprint">
        @if (series_events[element.ID]) {
          <div (mouseenter)="commentIconHover(series_events[element.ID])" (mouseleave)="commentIconLeave()"
            style="padding:2px 4px 2px 2px;">
            <i (click)="toggleComments(true)" class="icon-inline-comment"></i>
          </div>
        }
        @if (!series_events[element.ID]) {
          <div>
            <i (click)="toggleComments(true)" class="icon-comment-invert" style="width:28px;"></i>
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="star" stickyEnd>
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let element;" mat-cell>
        <mat-icon>more_vert</mat-icon>
      </td>
    </ng-container>
    <!--Row Defs-->
    @if (appScope.isNotMobile) {
      <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
      <tr (focus)="setComment($event, row, null)" *matRowDef="let row; columns: columns;" mat-row
      tabindex="0"></tr>
    }
    @if (!appScope.isNotMobile) {
      <tr *matHeaderRowDef="config.mobile_columns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: config.mobile_columns;" mat-row></tr>
    }
  </table>
}
@if (config?.columns?.length < 1) {
  <div>
    <!--TODO find another solution to providing feedback to user-->
    No columns have been set
  </div>
}
<!--<series-detail-table [hidden]="!show_series_details" [series_ids]="series_ids" [config]="config" [format_dict]="format_dict"></series-detail-table>-->
